import { MicroMoments } from '../models/micro-moments.interfaces';

export const MicroMomentsNearlyThereMocks: MicroMoments = {
  id: '',
  title: "Jordan, you're so close to earning Gold Medallion® Status!",
  description:
    'See how close you are to unlocking Gold Medallion benefits by viewing your progress in the Fly Delta app.',
  logo: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/nearly-status.gif',
    alt: 'Nearly There'
  },
  close: {
    path: '#',
    alt: 'close'
  },
  ariaLabel: {
    close: 'Close Micromoment'
  },
  disabled: false,
  loaded: true
};
